import {onUnmounted} from "#imports";
import {ref} from "vue";
import {createWebUrl} from "../lib/functions";
import {useNuxtApp} from "#app";

export function tyrionResponse() {
    const tyrionResponseStatus = ref<null | { status: string, msg: string }>(null);
    const tyrionResponseTimeout = ref<null | number | ReturnType<typeof setTimeout>>(null);

    onUnmounted(() => {
        if (tyrionResponseTimeout.value !== null) clearTimeout(tyrionResponseTimeout.value);
    })

    const {$i18n} = useNuxtApp();

    const clearTyrionResponseStatus = () => {
        tyrionResponseStatus.value = null;
    }

    const setTyrionResponseStatus = (status: string, msg: string, ignoreTimeout: boolean = false) => {
        tyrionResponseStatus.value = {status: status, msg: $i18n.t(msg)};
        if (!ignoreTimeout) {
            resetTyrionResponseTimeout();
        } else {
            if (tyrionResponseTimeout.value !== null) clearTimeout(tyrionResponseTimeout.value);
        }
    }

    const resetTyrionResponseTimeout = () => {
        if (tyrionResponseTimeout.value !== null) clearTimeout(tyrionResponseTimeout.value);
        tyrionResponseTimeout.value = setTimeout(() => {
            tyrionResponseStatus.value = null;
        }, 8000);
    }

    return {tyrionResponseStatus, setTyrionResponseStatus, clearTyrionResponseStatus}
}
